import { useCreateIngredient } from '../../hooks/useIngredients';

import { IngredientForm } from './IngredientForm';

import { PageHeader } from '@/components/common/PageHeader';
import { AppShell } from '@/components/layout/AppShell';
import { TopBar } from '@/components/layout/TopBar';
import { useNavigate } from '@/lib/router';
import { logger } from '@/lib/sentry';

export function NewIngredientPage() {
  const navigate = useNavigate();
  const createIngredient = useCreateIngredient();

  return (
    <AppShell>
      <TopBar title="Nouvel ingrédient" />
      <div className="mx-auto max-w-4xl p-4 md:p-6">
        <PageHeader
          title="Créer un ingrédient"
          subtitle="Ajouter un nouvel ingrédient au référentiel global"
          actions={
            <button
              type="submit"
              form="ingredient-form"
              disabled={createIngredient.isPending}
              className="rounded-lg bg-green-600 px-5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-700 disabled:opacity-60"
            >
              {createIngredient.isPending ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          }
        />
        <IngredientForm
          mode="create"
          isLoading={createIngredient.isPending}
          onCancel={() => void navigate({ to: '/ingredients' })}
          onSubmit={async (data) => {
            try {
              console.log('SUBMITTING NEW INGREDIENT DATA:', data);
              await createIngredient.mutateAsync(
                data as Parameters<typeof createIngredient.mutateAsync>[0],
              );
              await navigate({ to: '/ingredients' });
            } catch (error) {
              logger.error(error, { context: 'createIngredient' });
              alert(`Erreur de création : ${(error as Error).message || 'Vérifiez la console'}`);
            }
          }}
        />
      </div>
    </AppShell>
  );
}
